import { CHART_ENDPOINT, HttpService, httpService } from "../core/services/http.service"
import { NumbersDO } from "./numbers.data"
export class Number {
  private readonly API_PATH = '/graph/last_data'
  constructor(private httpService: HttpService) { }

  async load():Promise<NumbersDO> {
    const response = await this.httpService.query(`${CHART_ENDPOINT}${this.API_PATH}`, { method: "GET" })
    return await response.json() as NumbersDO;
  }
}

export const numberService = new Number(httpService)